module.exports = __webpack_public_path__ + "static/media/top-img.6338c4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/top-img.png
// module id = 1014
// module chunks = 2